import Landing from "@/pages/Landing";
import { Loader2 } from "lucide-react";
import { isNative } from "@/lib/capacitor";

/**
 * StartupGate handles the app's initial routing.
 * - NATIVE: Shows a safe loading screen while NativeStartupOverlay decides routing
 * - WEB: Landing page directly
 */
export const StartupGate = () => {
  if (!isNative) return <Landing />;

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-3 bg-background">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
      <p role="status" aria-live="polite" className="text-sm text-muted-foreground">Starting app…</p>
    </div>
  );
};

export default StartupGate;
